import { render, staticRenderFns } from "./InsightsDetailsFilters.vue?vue&type=template&id=8db8722a"
import script from "./InsightsDetailsFilters.vue?vue&type=script&lang=js"
export * from "./InsightsDetailsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports